import { PaymentsModule } from './PaymentsModule';

export const PaymentsDemo = () => {
  return <PaymentsModule flavor={'Demo'} />;
};
